// This really doesn't do anything, but makes the import code more consistent;

export const ngAriaModule = 'ngAria';
export const ngSanitizeModule = 'ngSanitize';
export const ngAnimateModule = 'ngAnimate';
